import { cartApi } from '../admin/api/masterApi'
import { fetchProducts } from './productApi'

function minimalProduct(assetId, title) {
  return {
    product_id: assetId,
    service_id: assetId,
    product_name: title || `Product #${assetId}`,
    price: null,
    discount_price: null,
    product_images: [],
  }
}

/** Same API as admin Cart page: GET /carts?user_id= */
export async function fetchCartsByUser(userId) {
  const rows = await cartApi.list({ user_id: userId })
  return rows || []
}

/**
 * Same API as admin Cart page: POST /carts
 * Body: { user_id, asset_id, quantity }
 */
export async function createCartItem({ user_id, asset_id, quantity }) {
  const existingRows = await fetchCartsByUser(user_id)
  const existing = (existingRows || []).find(
    (row) => String(row.asset_id) === String(asset_id)
  )
  if (existing) {
    const nextQuantity = Math.max(
      1,
      Number(existing.quantity) || 1,
      Number(quantity) || 1
    )
    if (nextQuantity !== Number(existing.quantity)) {
      return updateCartItem(existing.cart_id, {
        quantity: nextQuantity,
        user_id: Number(user_id),
        asset_id: Number(asset_id),
      })
    }
    return existing
  }

  return cartApi.create(
    JSON.stringify({
      user_id: Number(user_id),
      asset_id: Number(asset_id),
      quantity: Math.max(1, Number(quantity) || 1),
    }),
    { json: true }
  )
}

/** Same API as admin Cart page: PUT /carts/:cart_id */
export async function updateCartItem(cartId, payload) {
  return cartApi.update(
    cartId,
    JSON.stringify({
      user_id: Number(payload.user_id),
      asset_id: Number(payload.asset_id),
      quantity: Math.max(1, Number(payload.quantity) || 1),
    }),
    { json: true }
  )
}

/** Same API as admin Cart page: DELETE /carts/:cart_id */
export async function deleteCartItem(cartId) {
  await cartApi.remove(cartId)
}

export async function loadCartItemsForUser(userId) {
  const [rows, products] = await Promise.all([
    fetchCartsByUser(userId),
    fetchProducts().catch(() => []),
  ])
  const byId = new Map(
    (products || []).map((product) => [String(product.product_id), product])
  )

  return (rows || [])
    .map((row) => {
      const assetId = Number(row.asset_id)
      const product =
        byId.get(String(assetId)) ||
        minimalProduct(assetId, row.service_title)
      return {
        cartId: Number(row.cart_id),
        product,
        quantity: Math.max(1, Number(row.quantity) || 1),
      }
    })
    .filter((item) => Boolean(item.cartId))
}
